import { toast } from "react-toastify";
import { API, BACKEND_URL } from "../assets/staticData"

const useCache = () => {

  const sendClearRequest = async (query) => {
    try {
      let userToken = localStorage.getItem("userToken");

      const response = await fetch(`${BACKEND_URL}/cache-reset${query}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
      })

      const status = response.ok

      if (!status) throw new Error()

      toast.success("Cache cleared successfully");

      return status
    } catch (error) {
      toast.error("Cache was not cleared");
      return false
    }
  }

  const clear = async (...keys) => {
    let query = ''

    if (keys) {
      query = `?pattern=${keys.join(',')}`;
    }

    return sendClearRequest(query)
  }

  return {
    clear
  }
}

export default useCache